import type { SxProps, Theme } from '@mui/material/styles';

type ServiceHistoryStyleMap = {
    root: SxProps<Theme>
    timelineColumn: SxProps<Theme>
    timelineDot: SxProps<Theme>
    itemLink: SxProps<Theme>
    itemHeader: SxProps<Theme>
    itemMeta: SxProps<Theme>
    dateText: SxProps<Theme>
};

export const serviceHistoryStyles: ServiceHistoryStyleMap = {
    root: { position: 'relative' },
    timelineColumn: { display: 'flex', flexDirection: 'column', alignItems: 'center' },
    timelineDot: { width: 32, height: 32, borderRadius: '50%', bgcolor: 'primary.50', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 },
    itemLink: { flex: 1, pb: 1, textDecoration: 'none', color: 'inherit', '&:hover': { opacity: 0.75 } },
    itemHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 1 },
    itemMeta: { display: 'flex', alignItems: 'center', gap: 1, flexShrink: 0 },
    dateText: { whiteSpace: 'nowrap' },
};

export const serviceHistoryWrenchColor = '#009fe3';

export const getServiceHistoryItemStyles = (hasNext: boolean): SxProps<Theme> => ({
    display: 'flex',
    gap: 2,
    pb: hasNext ? 3 : 0,
});

export const getServiceHistoryTimelineLineStyles = (): SxProps<Theme> => ({
    width: 2,
    flex: 1,
    bgcolor: 'grey.200',
    my: 0.5,
});
